import React from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "../../context/AxiosInstance";
import { toast } from "react-toastify";

const ConfirmDeleteSalaireModal = ({ show, handleClose, salaire, token }) => {
  const handleDelete = async () => {
    try {
      await axios.delete("/salaires/", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          id_contrat: salaire.id_contrat,
          id_crg: salaire.id_crg,
          mois_salaire: salaire.mois_salaire,
          annee_salaire: salaire.annee_salaire,
        },
      });

      toast.success("Salaire supprimé avec succès");
      handleClose();
    } catch (err) {
      console.error(err);
      toast.error("Erreur lors de la suppression");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>🗑 Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Êtes-vous sûr de vouloir supprimer ce salaire&nbsp;?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Annuler
        </Button>
        <Button variant="danger" onClick={handleDelete}>
          Oui, supprimer
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteSalaireModal;
